<template>
  <div class="members-warpper">
    <div class="linkBtn flex justify-between">
      <my-brand :routerlist="routerlist" />
      <router-link to="/faq" class="faq">
        f.a.q
      </router-link>
    </div>
    <Table :columns="activeCols" :data="mermbersList" :loading="loading">
      <template slot="profile_id" slot-scope="{ row }">
        <div class="profile_id">
          <router-link
            class="site sameWidthFont"
            :to="`/profile/${row.address}`"
          >
            {{ row.address }}
          </router-link>
        </div>
      </template>
      <template slot="profileName" slot-scope="{ row }">
        <div>
          <p class="profileName">
            {{ row.profile_name }}
          </p>
        </div>
      </template>
      <template slot="memberships" slot-scope="{ row }">
        <div>
          <p class="memberships">
            {{ row.memberships }}
          </p>
        </div>
      </template>
    </Table>
  </div>
</template>

<script>
import { fetchGet } from "@/common/utils/request.js";
export default {
  data() {
    return {
      mermbersList: [],
      // routerlist:[{to:'/',name:'Home'},{to:'/projects',name:'projects'}],
      loading: false
    };
  },
  computed: {
    activeCols() {
      return [
        {
          title: "Wallet",
          slot: "profile_id",
          minWidth: 520,
        },
        {
          title: "Name",
          slot: "profileName",
          minWidth: 120,
        },
        {
          title: "Memberships",
          slot: "memberships",
          minWidth: 120,
        },
      ];
    },
    routerlist(){
      return [{to:'/',name:'Home'},{name:'Members'}];
    }
  },
  methods: {
    async getList() {
      const params = {
        pageNum: 1,
        showNum: 100,
      };
      try {
        this.loading = true;
        const res = await fetchGet("/api/members", params);
        this.mermbersList = res.data?.data?.Profiles;
        console.log({ res });
      } catch (error) {
        console.log(error);
      }finally{
        this.loading = false;
      }
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.members-warpper {
  padding: 40px 20px;
  .profile_id {
    p {
      cursor: pointer;
    }
  }
  .linkBtn {
    width: 100%;
    margin-bottom:20px;
    padding: 0 20px;
    .Breadcrumb{
      padding-top: 0;
    }
    .faq {
      display: block;
      color: #fff;
      border: 1px solid #fff;
      height: 36px;
      width: 100px;
      line-height: 36px;
      text-align: center;
      border-radius: 2px;
    }
  }
}
</style>